import { EventBus } from 'vtils'

export const pageBridge = new EventBus<{
  scroll: (payload: { scrollTop: number; headerParallaxRate: number }) => any
  ready: (payload: { pageHeaderHeight: number }) => any
}>()
